import {
  collection,
  getFirestore,
  Query,
  query,
  where,
} from "firebase/firestore";
import { ArtistSubdomain } from "models/artistSubdomain";
import { useCollection } from "react-firebase-hooks/firestore";
import { useParams } from "react-router-dom";

export const useArtistGroupSubdomain = (artistId?: string) => {
  const params = useParams<{ artistId: string }>();

  const [snapshot, loading] = useCollection(
    query(
      collection(getFirestore(), "artist_subdomain"),
      where("artistGroupId", "==", artistId || params.artistId),
    ) as Query<ArtistSubdomain>,
  );

  return [snapshot?.docs?.[0], loading] as const;
};
